import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const ROLE_LEVEL = { support: 1, editor: 2, owner: 3 };
const isKnown = (r) => typeof r === 'string' && Object.prototype.hasOwnProperty.call(ROLE_LEVEL, r);

// Même règle que functions/adminAccess.js (resolveAdminRole), sans ADMIN_UID (côté serveur seulement).
export function resolveRole(claims) {
  if (!claims || claims.admin !== true) return null;
  if (claims.adminRole === undefined) return 'owner';
  return isKnown(claims.adminRole) ? claims.adminRole : 'support';
}

export default function useAdminRole() {
  const { currentUser, loading: authLoading } = useAuth();
  const [state, setState] = useState({ role: null, loading: true });

  useEffect(() => {
    let cancelled = false;
    if (authLoading) return undefined;
    if (!currentUser) {
      setState({ role: null, loading: false });
      return undefined;
    }
    setState((s) => ({ ...s, loading: true }));
    Promise.resolve()
      .then(() => currentUser.getIdTokenResult())
      .then((res) => { if (!cancelled) setState({ role: resolveRole(res.claims), loading: false }); })
      .catch(() => { if (!cancelled) setState({ role: null, loading: false }); });
    return () => { cancelled = true; };
  }, [currentUser, authLoading]);

  return state;
}
export { useAdminRole };
